<template>
  <div class="b2c-order">
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="6">
            <h4>
              Kích hoạt gói cước
            </h4>
          </b-col>
        </b-row>
        <div class="pb-1 d-flex justify-content-start align-items-center ">
          <label class="mr-2 font-14">Số thuê bao</label>
          <b-input-group style="width:200px">
            <b-form-input v-model="phone" placeholder="Nhập số thuê bao" size="sm" @keypress.enter="quickSearch"/>
            <b-input-group-append is-text role="button" @click="quickSearch">
              <feather-icon icon="SearchIcon"/>
            </b-input-group-append>
          </b-input-group>
        </div>
        <p v-if="!isSearchForm">Vui lòng nhập số thuê bao và xử lý</p>
        <b-row>
          <b-col v-if="isSearchForm" cols="12">
            <p>Tổng gói cước tìm thấy: {{totalRecords}}</p>
            <vue-good-table :columns="fields" :isLoading.sync="isLoading" :line-numbers="true" :rows="rows"
            >
              <template
                  slot="table-row"
                  slot-scope="props"
              >
              <span v-if="props.column.field === 'action'">
               <button class="btn btn-danger" type="button" @click="handlePackActivation">Kích hoạt gói</button>
              </span>
              </template>
            </vue-good-table>
          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>

import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';
import SearchSelect from "../components/select/SearchSelect.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BCardText,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    SearchSelect
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  watch: {
    $route(to, from) {
      this.isSearchForm = false;
    }
  },
  methods: {
    async handlePackActivation() {

      const res = await this.$bvModal.msgBoxConfirm('Bạn đang thực hiện kích hoạt gói cho số thuê bao này. Vui lòng xác nhận.', {
        title: 'Please Confirm',
        size: 'sm',
      })
      if (res) {
        this.loading(true);
        this.isLoading = true;
        useJwt.post(`activePackage/${this.phone}`,).then(response => {
          if (response.data.code == 200) {
            this.$toast({
              component: ToastificationContent,
              props: {title: 'kích hoạt thành công ', icon: 'CheckSquareIcon', variant: 'primary'}
            })

          } else {
            this.$toast({
              component: ToastificationContent,
              props: {title: 'kích hoạt thất bại', icon: 'CheckSquareIcon', variant: 'danger'}
            })
          }
          this.loading(false);
          this.isLoading = false;
        }).catch(error => {
          this.loading(false);
          this.isLoading = false;
        })
      }
    },
    quickSearch() {
      this.loadItems();
    },
    loadItems() {
      this.loading(true);
      this.isLoading = true;
      useJwt.get(`getCurrentPackage1/${this.phone}`).then(response => {
        this.isSearchForm = true
        this.rows = response.data.result.map(i => {
          return {
            ...i,
            phone: this.phone

          }
        }) ?? [];
        this.totalRecords = this.rows.length;
        this.loading(false);
      }).catch(error => {
        this.loading(false);
        this.isLoading = false;
      })
    },
  },
  data() {
    return {
      isSearchForm: false,
      phone: '',
      searchString: "",
      isLoading: false,
      totalRecords: 0,
      rows: [],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      searchTerm: '',
      currentItem: {},
      fields: [
        {
          field: 'phone',

          label: 'Số thuê bao',
        },
        {
          field: 'packageName',
          label: 'Tên gói',
        },
        {
          field: 'serviceCode',
          label: 'Mã gói',
        },
        {field: 'action', label: 'Xứ lý', width: '200px', tdClass: 'text-center', sortable: false}
      ],
      msisdn: "0",
      params: {
        msisdn: "",
        from: "",
        to: ""
      },
      required
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.font-14 {
  font-size: 14px;
}
</style>
<style>
</style>
